import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react'
import services from '../../ioc/services';
import Select from 'react-select';

export default function AdminsDropdown({ valueUpdater, defaultValue = "" }) {

  const [admins, setAdmins] = useState([]);

  const [defaultSelected, setDefaultSelected] = useState(null);

  useEffect(() => {

    services.api.admin.getAdmins()
      .then(res => {
        setAdmins(res.map(a => ({
          "value": a.user_id,
          "label": `${a.firstName} ${a.lastName}`
        })))

        const admin = res.find(r => r.user_id == defaultValue);

        if (admin) {
          setDefaultSelected({
            "value": admin.user_id,
            "label": `${admin.firstName} ${admin.lastName}`
          })
        }




      })

  }, [])

  return (

    <div className='flex-1'>



      <Select
        onChange={(v) => {
          setDefaultSelected(v)
          valueUpdater(v)
        }}
        options={admins}
        value={defaultSelected}
        styles={{
          control: (base, state) => ({
            ...base,
            backgroundColor: '#f5f5f5',
            color: "#000",
            border: 'none',
            outline: 'none',
            padding: '10px 5px'
          })
        }}
      />
    </div>


  )
}